/*DO NOT MODIFY THIS FILE, THIS FILE WILL BE REPLACED ON BUILD*/

/*FOR UPDATES MODIFY THE ORIGINAL FILE ON FOLDER "UTILS"*/
// import { useSearchParams } from 'next/navigation'
import Head from 'next/head'
import { useEffect, useMemo, useState } from 'react'

import Components from 'components'

import { getStaticProps } from 'utils/templates/pages/getStaticISRProps'
import { getStaticPaths } from 'utils/templates/pages/getStaticPaths'

export { getStaticProps, getStaticPaths }

export default function Index(props: any) {
  const { pageConfig, date, timeRevalidate } = props
  const [headerPage, setHeaderPage] = useState({})
  const [articles, setArticles] = useState([])
  // const searchParams = useSearchParams()
  // eslint-disable-next-line prefer-const
  let gitversion = 'eded9e76'

  function selectTypeContent(
    reactComponent: string,
    liferayFields: any,
    hashObjects: string
  ) {
    return Components(
      reactComponent,
      pageConfig?.hashPage,
      hashObjects,
      liferayFields
      // homeCards
    )
  }

  function setArticleData(arrayArticles: any) {
    const isSelfcare = arrayArticles.find(
      (component: { reactComponent: string }) =>
        component.reactComponent.toLowerCase() === 'menuheaderott'
    )

    return (
      <>
        <div id="header-section">
          {arrayArticles.length &&
            arrayArticles.map((objArticle: any) => {
              if (
                String(objArticle?.reactComponent)
                  .toLowerCase()
                  .indexOf('header') !== -1
              ) {
                return selectTypeContent(
                  objArticle?.reactComponent,
                  objArticle?.fields,
                  objArticle?.hashObjects
                )
              }
            })}
        </div>
        {!isSelfcare && (
          <div id="main-content">
            {arrayArticles.length &&
              arrayArticles.map((objArticle: any) => {
                if (
                  String(objArticle?.reactComponent)
                    .toLowerCase()
                    .indexOf('header') === -1 &&
                  String(objArticle?.reactComponent)
                    .toLowerCase()
                    .indexOf('footer') === -1
                ) {
                  return selectTypeContent(
                    objArticle?.reactComponent,
                    objArticle?.fields,
                    objArticle?.hashObjects
                  )
                }
              })}
          </div>
        )}
        {isSelfcare && (
          <div className={'selfcare'}>
            <div className={'selfcare__container'}>
              <div className={'selfcare__content'}>
                <>
                  {arrayArticles.length &&
                    arrayArticles.map((objArticle: any) => {
                      if (
                        String(objArticle?.reactComponent)
                          .toLowerCase()
                          .indexOf('menuloggedinott') >= 0
                      ) {
                        return selectTypeContent(
                          objArticle?.reactComponent,
                          objArticle?.fields,
                          objArticle?.hashObjects
                        )
                      }
                    })}
                </>
                <main>
                  {arrayArticles.length &&
                    arrayArticles.map((objArticle: any) => {
                      if (
                        String(objArticle?.reactComponent)
                          .toLowerCase()
                          .indexOf('header') === -1 &&
                        String(objArticle?.reactComponent)
                          .toLowerCase()
                          .indexOf('footer') === -1 &&
                        String(objArticle?.reactComponent)
                          .toLowerCase()
                          .indexOf('menuloggedinott') === -1
                      ) {
                        return selectTypeContent(
                          objArticle?.reactComponent,
                          objArticle?.fields,
                          objArticle?.hashObjects
                        )
                      }
                    })}
                </main>
              </div>
            </div>
          </div>
        )}
        <div id="footer-section">
          {arrayArticles.length &&
            arrayArticles.map((objArticle: any) => {
              if (
                String(objArticle?.reactComponent)
                  .toLowerCase()
                  .indexOf('footer') !== -1
              ) {
                return selectTypeContent(
                  objArticle?.reactComponent,
                  objArticle?.fields,
                  objArticle?.hashObjects
                )
              }
            })}
        </div>
      </>
    )
  }

  function setHeaderPageArray({ settings, metatags }: Record<string, any>) {
    return (
      <Head>
        <title>
          {settings?.htmlTitle_i18n?.[pageConfig?.language?.pageLanguage]
            ?.length > 0
            ? settings?.htmlTitle_i18n?.[pageConfig?.language?.pageLanguage]
            : settings?.htmlTitle}
        </title>
        {settings?.description ? (
          <meta
            name="description"
            content={
              settings?.description_i18n[pageConfig?.language?.pageLanguage]
                ?.length > 0
                ? settings?.description_i18n[pageConfig?.language?.pageLanguage]
                : settings?.description
            }
            lang={
              pageConfig.language.pageLanguage !== ''
                ? pageConfig.language.pageLanguage
                : process.env.NEXT_PUBLIC_DEFAULTLOCALE
            }
          />
        ) : (
          ''
        )}
        {metatags?.map((obj: Record<string, any>) => {
          return (
            <meta
              name={Object.keys(obj)[0]}
              content={obj[Object.keys(obj)[0]]}
              key={`${obj[Object.keys(obj)[0]]}+${Object.keys(obj)[0]}`}
            />
          )
        })}
      </Head>
    )
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      console.log(
        '%cDirectv%cSítios %c- Last revalidate: %c' +
          `${
            String(new Date(date)) !== 'Invalid Date'
              ? `${new Date(
                  date
                )} - Next revalidate in ${timeRevalidate} seconds`
              : 'unavailable on SSR'
          }` +
          ' - version:::::::: ' +
          gitversion,
        'font-family: Arial;font-size:20px;color:#077cc0',
        'color:black;font-size:12px',
        'color:#078618',
        'color:#000'
      )
      ;(async function () {
        if (pageConfig?.seo) {
          setHeaderPage(pageConfig.seo)
        }
        console.log({ pageConfig })
        setArticles(pageConfig?.articles)
      })()
    }
  }, [JSON.stringify(pageConfig.articles), JSON.stringify(pageConfig.seo)])

  return (
    <>
      {setHeaderPageArray(headerPage)}
      {articles?.length ? setArticleData(articles) : <b>Loading...</b>}
    </>
  )
}
